import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TelegramIcon from "@material-ui/icons/Telegram";
import { animateScroll as scroll } from "react-scroll";
import { ThemeSwitcher } from "../ThemeSwitcher";

// www.linkedin.com/in/rinat-razhapov-8998a0209

function MyInfo() {
  const themesColors = React.useContext(ThemeSwitcher);

  const handleScrollToBottom = () => {
    scroll.scrollToBottom();
  };

  return (
    <>
      <Fade bottom>
        <Info>
          <Title>
            <Desc props={themesColors}>
              <h1>
                Hello, my name is Rinat <span>&#128578;</span>
              </h1>
              <p>front-end developer</p>
              <p>stack: react, redux, next.js, typescript, vue, vuex, nuxt.js</p>
            </Desc>
            <Links>
              <a className="git-icon icon" href="https://github.com/r33n99">
                <GitHubIcon />
              </a>
              <a className="linked-icon icon" href="https://www.linkedin.com/in/rinat-razhapov-8998a0209/">
                <LinkedInIcon />
              </a>
              <a className="telega-icon icon" href="https://t.me/r33n99">
                <TelegramIcon />
              </a>
            </Links>
            <ButtonContacts onClick={handleScrollToBottom}>
              <span>contacts</span>
              <ArrowDownwardIcon />
            </ButtonContacts>
          </Title>
        </Info>
      </Fade>
      <Fade left>
        <Photo src="images/man.gif" />
      </Fade>
    </>
  );
}

export default MyInfo;

const Info = styled.div`
  font-size: 25px;
  text-align: start;
  margin-right: 50px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
`;

const Photo = styled.img`
  width: 320px;
  border-radius: 10px;
  @media (max-width: 768px) {
    width: 230px;
    margin-bottom: 15px;
  }
`;
const Title = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    align-items: center;
  }
`;

const Desc = styled.div`
  color: inherit;
  p {
    margin-bottom: 10px;
  }

  word-spacing: 1.5px;
  h1 {
    font-size: 40px;
    margin-bottom: 5px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 28px;
    }
    font-size: 18px;
  }
`;

const ButtonContacts = styled.button`
  background: #55198b;
  border-radius: 5px;
  width: 200px;
  color: white;
  border-radius: 4px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  height: 56px;
  border: none;
  letter-spacing: 1.8px;
  cursor: pointer;
  transition: background 0.3s ease-in-out 0s;
  img {
    width: 20px;
    margin-left: 6px;
  }
  &:hover {
    transition: all 0.3s ease-in-out 0s;
    background: #f5f11c;
    color: #171c28;
    img {
      color: white;
    }
  }
`;

const Links = styled.div`
  margin: 10px 0;
  svg {
    margin-right: 10px;
    font-size: 30px;
  }
  a {
    cursor: pointer;
    align-items: center;
    margin: 0 auto;
    color: #fff;
    &:hover {
      color: ${(themesColors) => themesColors.theme.url};
    }
  }
  .icon {
    display: inline-block;
    fontsize: 44px;
    animation: float 5s ease-in-out infinite;
  }
 
  .linked-icon {
    animation-delay: 1s;
  }

  .telega-icon {
    animation-delay: 2s;
  }
  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;
